import styled from "styled-components";
import { colors } from "../../utils/styles/colors";
import { media } from "../../utils/styles/media";

export const ModalGuidelinesContainer = styled.div`

position: fixed;
    overflow-y: auto;
    top:0;
    left: 0; 
    height: 100vh;
    width: 100vw;
    background-color: ${colors.modalBackground};
    display: flex;
    align-items: center;
    z-index: 100;
    display: flex;
    flex-direction: column;
    padding: 50px;
    .closeOutside{
        width: 40px;
        align-self: flex-end;
        cursor: pointer;
    }
    .policyBody{
        background-color: #ffffff;
        margin: 50px;
        border-radius: 30px;
        padding: 40px 60px;
        .policyHeader{
            .title{
                font-size: 2rem;
                margin-bottom: 10px;
            }
            .close{
                display: none;
            }
        } 
        
        /* .update{
            background-color: ${colors.hightlight};
            color: #ffffff;
            width:300px;
            padding: 8px;
            border-radius: 5px;
            margin-bottom: 20px;
            text-align: center;
        } */
        span{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex-wrap: wrap;
            color: ${colors.darkGrey};
            h2{
                    margin: 20px 0;
                }
                div{
                    background-color: ${colors.hightlight};
                    color: #ffffff;
                    padding: 8px 25px;
                    border-radius: 5px;
                    margin-bottom: 20px;
                    text-align: left;
                    align-self: flex-start;
                }
                h3{
                    margin-bottom: 10px;
                    margin-top: 20px;
                }
                p{
                    margin: 5px 0; 
                    text-align: justify;
                }
                .subIndex{
                    margin-left: 20px;
                    a{
                        color: #000000;
                    }
                }
                h4{
                    font-weight: 700;
                    margin-top: 10px;
                    margin-bottom: 5px;
                }
        }
        
    }


    /**-----------Responsive----------- */
    ${media.largeDesktop}{

    }
    ${media.desktop}{
        
    }
    ${media.laptop}{

        .policyBody{
        padding: 30px 40px;
        }
    }

    ${media.largeMobile}{

        padding: 0;
        background-color: #ffffff;
        //overflow-y: initial;
        width:100vw;
        .closeOutside{
            display: none;
        }

        .policyBody{
            margin: 0;
            padding: 20px 30px;
            width: 100%;
            .policyHeader{
                display: flex;
                justify-content: flex-end;
                .close{
                    display: block;
                    width: 25px;
                }
            }
            span{
                margin: 0;
                .subIndex{
                    margin-left: 20px;
                    a{
                        color: #000000;
                        font-size: 0.9rem;
                    }
                }
            } 
                      
        }
    }

`